import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-ds-pagination',
  standalone: true,
  imports: [NgbPaginationModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsPaginationComponent {
  readonly collectionSize = input.required<number>();
  readonly page = input.required<number>();

  readonly pageSize = input<number>(10);
  readonly maxSize = input<number>(3);
  readonly ariaLabel = input<string>('Pagination');

  readonly pageChange = output<number>();

  protected onPageChange(page: number): void {
    this.pageChange.emit(page);
  }
}
